<div class="validation">
  <span class="ktitle strong v-title">Validation</span>
  <div class="container">
    <div class="tab-row">
      <div
        class="tab"
        [ngClass]="{ selected: selectedTab === 'Need Validation' }"
        (click)="setSelectedTab('Need Validation')"
      >
        <mat-icon class="icon" fontSet="material-icons-round">warning</mat-icon>
        <span class="klabel-large">Need Validation</span>
      </div>
      <div
        class="tab"
        [ngClass]="{ selected: selectedTab === 'Previously Validated' }"
        (click)="setSelectedTab('Previously Validated')"
      >
        <mat-icon class="icon" fontSet="material-icons-round"
          >file_download_done</mat-icon
        >
        <span class="klabel-large">Previously Validated</span>
      </div>
    </div>
    <div class="content">
      <app-table
        class="validation-table"
        [tableData]="tableData"
        [hideShowDetailsButton]="false"
        [hideViewInactiveButton]="true"
        [hideAdvancedFilters]="true"
        [hideEditButton]="true"
        [hideCreateNewButton]="true"
        [isLoading]="isLoading"
        (sortColumn)="sortColumn($event)"
        (itemsPerPageChange)="onItemsPerPageChange($event)"
        (pageChanged)="onPageChanged($event)"
        (showItemDetails)="openCourseValidationDetails($event)"
        (filterColumn)="search($event)"
      ></app-table>
      <app-loading-spinner
        class="spinner"
        *ngIf="isLoading"
      ></app-loading-spinner>
      <span class="error" *ngIf="error">{{ error?.message }}</span>
    </div>
  </div>
</div>